import listObjects from "./listObjects.component";

const listObjectsModule = angular
  .module("app.components.listObjects", [])
  .component("listObjects", listObjects);

export default listObjectsModule;



// WEBPACK FOOTER //
// ./src/components/listObjects/listObjects.module.js